import {setUrl} from "@/services/endpoints/endpoint-helper.ts";

const PDF_ENDPOINTS = {
    GET_PROJECT_PREVIEW: (organisationId: string, projectId: string) => setUrl(`pdf/${organisationId}/project/${projectId}`)
}

export default PDF_ENDPOINTS;